import { createRouter, createWebHistory } from 'vue-router';
import store from '@/store';
import { publicRoutes, appRoutes } from '@/routes';

const views = {
  signup: () => import('@/views/auth/SignUp'),
  signin: () => import('@/views/auth/SignIn'),
  signout: () => import('@/views/auth/SignOut'),
  forgotpassword: () => import('@/views/auth/ForgotPassword'),
  resetpassword: () => import('@/views/auth/ResetPassword'),
  apikeys: () => import('@/views/app/Profile'),
  profile: () => import('@/views/app/Profile'),
  subscription: () => import('@/views/app/Subscription'),
};

const router = createRouter({
  history: createWebHistory(),
  routes: [
    ...publicRoutes,
    ...appRoutes.map(route => ({ ...route, component: views[route.name] })),
    { path: '/:pathMatch(.*)*', component: () => import('@/views/NotFound.vue') },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.staticDocument) {
    window.location.assign(to.fullPath);
    return next(false);
  }

  if (to.path.startsWith('/app/')) {
    try {
      await store.dispatch('auth/fetchSession');
    } catch {
      // A failed session check falls through to the sign-in redirect below.
    }
    if (!store.getters['auth/isLoggedIn']) {
      return next({ name: 'signin', query: { redirect: to.fullPath } });
    }
  }

  next();
});

export default router;
